import { render, staticRenderFns } from "./SingleLayerInfos.vue?vue&type=template&id=c5d9e6e4&scoped=true"
import script from "./SingleLayerInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerInfos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerInfos.vue?vue&type=style&index=0&id=c5d9e6e4&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c5d9e6e4",
  null
  ,true
)

export default component.exports